/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-07-14 11:36:57
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-08-18 16:22:45
 * @FilePath: \cmes-project-web\src\store\settings\feildWidth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
module.exports = {
  /**
   * 日期类型列宽值
   */
  datetypewidth: 140,
  /**
   * 时间类型列宽值
   */
  datetimetypewidth: 180,
  /**
   * 状态类型列宽值
   */
  statewidth: 80,
  /**
   * 姓名类型列宽值
   */
  namewidth: 80,
  /**
   * 单据类型名列宽值
   */
  doctypewidth: 100,
  /**
   * 单据编码列宽值
   */
  docnumberwidth: 140,
  /**
   * 供应商名列宽值
   */
  suppliernamewidth: 180,
  /**
   * 客户名列宽值
   */
  customernamewidth: 180,
  /**
   * 工厂名列宽值
   */
  actorynamewidth: 100,
  /**
   * 仓库名列宽值
   */
  whnamewidth: 140,
  /**
   * 物料编码列宽值
   */
  materielcodewidth: 140,
  /**
   * 物料名称列宽值
   */
  materielnamewidth: 160,
  /**
   * 物料规格列宽值
   */
  materialsggwidth: 120,
  /**
   * 单位列宽值
   */
  unitwidth: 60,
  /**
   * 单价类型列宽值
   */
  pricetypewidth: 80,
  /**
   * 数值类型列宽值
   */
  valuetypewidth: 80,
  /**
   * 行号列宽值
   */
  lineNumberWidth: 80,
  /**
   * 序号
   */
  serialWidth: 50,
  /**
   * 长文本
   */
  longTextWidth: 220,
  /**
   * 电话号码
   */
  phonewidth: 120,
  /**
   * 描述
   */
  problemDescriptionWidth: 200,
  /**
   * 标题列宽值
   */
  titlenamewidth: 220
};